// extracted by mini-css-extract-plugin
export var addToCartButton = "_tw-b";
export var arrowButtonContainer = "_tw-9";
export var arrowButtonIcon = "_tw-a";
export var carouselArrowButton = "_tw-6";
export var carouselElementContainer = "_tw-1";
export var left = "_tw-7";
export var productDisplayCarouselContainer = "_tw-0";
export var productTileContainer = "_tw-2";
export var productTileImage = "_tw-4";
export var productTileImageContainer = "_tw-3";
export var productTileTitle = "_tw-5";
export var right = "_tw-8";
export var sliderOverflow = "_tw-c";